<template>
  <div class="background" v-cloak>
    <div class="header-img"></div>
    <div class="pkg-info">
      <div class="item-title">
        <h3>{{package.name}}</h3>
      </div>
      <p class="pkg-desc">{{package.remark}}</p>
      <div class="pkg-summary">
        <div class="item-count">共 {{itemsCount}} 项体检项目</div>
        <p class="pkg-price">￥{{Number(package.sale_price)?Number(package.sale_price).toFixed(2):0}}</p>
      </div>
    </div>
    <div class="content">
      <van-tabs v-model="tabIndex" scrollspy sticky>
        <van-tab title="套餐项目">
          <div>
            <div class="items-wrapper" v-for="(cate,cateIndex) in noEmptyCategories" :key="cate.id">
              <div class="category-header">
                <img :src="getCategoryIcon(cate.id)" />
                {{cate.categoryName}}<span>共 {{cate.items.length}} 项</span>
              </div>
              <div class="item-list">
                <a v-for="(it,index) in cate.items" :key="it.item_code" href="javascript:;" @click="popupItem(it)">
                  <div class="checkitem-row">
                    <div class="checkitem-title">
                      <span class="checkitem-name">{{it.alias && it.alias !=="" ? it.alias : it.item_name}}</span>
                      <!-- <span class="checkitem-price">￥{{it.price}}</span> -->

                      <van-icon name="arrow" size="12px" style="margin-top:6px" />
                    </div>
                    <span class="checkitem-desc">{{it.description}}</span>
                    <div class="checkitem-footer" v-show="it.general_tips !=null || it.important_tips!=null">
                      <span v-show="it.general_tips" class="checkitem-tips">{{it.general_tips}}</span>
                      <span v-show="it.important_tips" class="checkitem-tips red">{{it.important_tips}}</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="体检须知">
          <div class="notice">
            <p style="white-space: pre-wrap;" v-html="package.exam_notice"></p>
            <!-- <img src="@/assets/images/tjxz.png" /> -->
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 底部 -->
    <div class="footer fixed-footer">
      <div class="agreement-wrap" v-if="package.appointment_status == 1">
        <van-checkbox v-model="isAgree" shape="square" icon-size="16px">已阅读并同意《体检须知》内容</van-checkbox>
      </div>
      <div class="order-summary">
        <div class="order-price">
          价格:
          <span class="price">￥{{Number(package.sale_price).toFixed(2)}}</span>
        </div>
        <van-button round class="order-button" size="large" @click="beforeOrder()" :disabled="!isAgree"
          v-if="package.appointment_status == 1">
          立即预约
        </van-button>
        <van-button round class="order-button--disable" size="large" @click="showDisableNotice" v-else>
          不可预约
        </van-button>
      </div>
    </div>
    <!-- 弹出窗口内容 -->
    <van-popup v-model="showItemDetail" class="item-popup">
      <div class="item-wrapper">
        <div class="item-header">{{currentItem.item_name}}</div>
        <div class="item-content">
          <div class="item-info-box">
            <h3>检查内容</h3>
            <p class="item-info-text">{{currentItem.description}}</p>
          </div>
          <div class="item-info-box">
            <h3>临床意义</h3>
            <p class="item-info-text">{{currentItem.meanning}}</p>
          </div>
          <div class="item-info-box">
            <h3>项目提示</h3>
            <p class="item-info-text">{{currentItem.general_tips}}</p>
            <p class="item-info-text">{{currentItem.important_tips}}</p>
          </div>
        </div>
        <div class="item-footer">
          <van-button type="info" @click="hidePopupItem" round size="small" style="width:100px">确定</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 显示体检人员弹窗 -->
    <van-popup v-model="showProfile" round closeable position="bottom" :style="{ height: '80%' }">
      <h3 class="popup-title">请选择体检人员</h3>
      <div style="padding-top:36px">
        <profileList @select="selectProfile" />
      </div>
    </van-popup>

    <van-dialog v-model="showSurveyDialog" show-cancel-button confirm-button-text="去填写" cancel-button-text="跳过"
      @confirm="goSurvey()" @cancel="skipSurvey()">
      <img src="@/assets/images/img-survey-vector.png" width="100%" />
    </van-dialog>
  </div>
</template>
<script>
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'
  import * as api_package from '@/api/package'
  import {
    getHospital
  } from '@/api/hospital'
  import {
    checkUserSurvey
  } from '@/api/survey'
  import profileList from "@/components/profileList";
  const itemcategories = [{
      id: 1,
      categoryName: "一般检查",
      items: []
    },
    {
      id: 2,
      categoryName: "检验项目",
      items: []
    },
    {
      id: 3,
      categoryName: "辅助检查",
      items: []
    },
    {
      id: 4,
      categoryName: "其它项目"
    }
  ];

  export default {
    components: {
      profileList
    },
    data() {
      return {
        package: {
          name: "入职体检套餐",
          price: 200,
          description: "",
          notice: ""
        },
        notice: "", //体检须知
        tabIndex: 0,
        total: 200,
        currentItem: Object,
        categories: itemcategories,
        itemsCount: 5,
        showItemDetail: false,
        showProfile: false,
        showSurveyDialog: false,
        isAgree: false,
        surveyId: 0, //健康问卷ID值
      };
    },
    created() {
      let id = this.$route.query.id;
      let hospid = this.$route.query.hospid;
      let _this = this;
      itemcategories[0].items = [];
      itemcategories[1].items = [];
      itemcategories[2].items = [];
      itemcategories[3].items = [];
      if (id && hospid) {
        api_package.getPackageDetail(hospid, id).then(res => {
          if (res.data) {
            _this.package = res.data;
            _this.itemsCount = _this.package.items.length;
            for (let i = 0; i < _this.package.items.length; i++) {
              const item = _this.package.items[i];
              if (!item.meanning) {
                item.meanning = "暂无相关说明";
              }
              if (!item.description) {
                item.description = "暂无相关说明";
              }
              switch (item.type) {
                case 0:
                  itemcategories[0].items.push(item);
                  break;
                case 1:
                  itemcategories[2].items.push(item);
                  break;
                case 2:
                  itemcategories[1].items.push(item);
                  break;
                default:
                  itemcategories[3].items.push(item);
                  break;
              }
            }
          }
        })
      }

    },
    mounted() {
      let hospid = this.$route.query.hospid;
      getHospital(hospid).then(res => {
        this.notice = res.data.notice;
      })
    },
    props: ["id"],
    methods: {
      // 获取项目分类的图标
      getCategoryIcon(id) {
        switch (id) {
          case 1:
            return require("@/assets/images/icon-medical1.png");
            break;
          case 2:
            return require("@/assets/images/icon-medical2.png");
            break;
          case 3:
            return require("@/assets/images/icon-medical3.png");
            break;
          case 4:
            return require("@/assets/images/icon-medical4.png");
            break;
          default:
            return require("@/assets/images/icon-medical1.png");
            break;
        }
      },
      // 弹出窗口显示项目详情
      popupItem(item) {
        this.currentItem = item;
        this.showItemDetail = true;
      },
      hidePopupItem() {
        this.showItemDetail = false;
      },
      beforeOrder() {
        let text = this.package.notice_content;
        if (!text) {
          this.showProfile = true;
          return;
        }
        this.$dialog.confirm({
            title: '预约提醒',
            message: text,
            confirmButtonText: '继续预约',
          })
          .then(() => {
            this.showProfile = true
          })
          .catch(() => {
            // on cancel
          });
      },
      //submitOrder
      submitOrder() {
        this.$router.push("/namelist");
      },

      ...mapActions(
        "user", {
          setActiveUserProfile: "setActiveUserProfile"
        }
      ),
      ...mapActions(
        "order", {
          setPackage: "setPackage"
        }
      ),
      ...mapActions(
        "hospital", {
          getHospitalInfo: "getHospitalInfo"
        }
      ),
      selectProfile(profile) {
        console.log(profile);

        //判断性别是否相符
        if (this.package.sex_limit !== 0 && this.package.sex_limit !== profile.sex) {
          console.log("package sex limit:" + this.package.sex_limit + "profile sex :" + profile.sex);
          this.$toast("体检人员性别与套餐不符，请重新选择");
          return;
        }
        this.showProfile = false;
        this.setActiveUserProfile(profile);
        this.setPackage(this.package);
        //显示填写健康问卷的窗口
        checkUserSurvey(this.$route.query.hospid, profile.id).then(
          res => {
            console.log(res)
            if (res.code == 200 && res.data && res.data.surveyId != 0 && !res.data.existsSurvey) {
              this.surveyId = res.data.surveyId;
              this.showSurveyDialog = true;
            } else {
              this.$router.push("submitOrder");
            }
          }
        )
      },
      showDisableNotice() {
        this.$toast("此套餐暂不可预约，如有需求请电话联系体检中心");
      },
      //显示填写健康问卷的窗口
      showSurveyDialogBox() {

      },
      goSurvey() {
        this.showSurveyDialog = false;
        this.$router.push({
          path: "survey/fill",
          query: {
            surveyId: this.surveyId,
            from: 'personal'
          }
        });
      },
      skipSurvey() {
        this.showSurveyDialog = false;
        this.$router.push("submitOrder");
      }
    },
    computed: {
      ...mapState({
        hospInfo: state => state.hospital.hospInfo
      }),
      noEmptyCategories: function () {
        return this.categories.filter(cate => cate.items.length > 0);
      }
    },
  };
</script>

<style lang="less" scoped>
  [v-cloak] {
    display: none;
  }

  .background {
    background: #f1f1f1;

    .pkg-info {
      background: #ffffff;
      margin-bottom: 10px;
      position: relative;
      padding: 16px 20px;

      h3 {
        font-size: 18px;
        flex: 1;
        line-height: 32px;
      }

      .pkg-desc {
        color: rgba(0, 0, 0, 0.45);
        font-size: 13px;
      }

      .pkg-summary {
        display: flex;
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px solid #ebedf0;
      }

      .pkg-price {
        color: #f63;
        font-size: 18px;
        text-align: right;
      }

      .pkg-price:first-letter {
        font-size: 14px;
      }

      .item-count {
        font-size: 14px;
        color: #888;
        flex: 1;
      }

      .item-right {
        display: flex;
        padding-top: 0.1rem;

        span {
          // padding: 0.07rem 0.2rem;
          width: 1.1rem;
          height: 0.35rem;
          display: inline-block;
          text-align: center;
          line-height: 0.35rem;
          border: 1px solid #ccc;
          font-size: 0.18rem;
          margin-right: 0.14rem;
          border-radius: 0.3rem;
        }
      }
    }

    .package-desc {
      padding: 20px;
      background: #ffffff;
      font-size: 14px;
      line-height: 24px;
      color: #888;

      h4 {
        font-size: 16px;
        color: #333;
      }
    }

    .title {
      background: #fff;
      padding: 0.2rem;

      p {
        margin: 0 0.2rem;
        padding-left: 0.2rem;
        font-size: 0.26rem;
        border: 1px solid #e6e7e9;
        border-radius: 0.1rem;
        background: #f5fbfb;
        box-shadow: 0px 2px 10px #f3f3f3;
        word-break: break-all;
      }
    }

    .content {
      background: #f1f1f1;
      position: relative;
      padding-bottom: 60px;

      .top {
        background: #fff;
        display: flex;
        border-bottom: 1px solid #eeeeee;
        position: -webkit-sticky;
        position: sticky;
        top: 0px;

        span {
          flex: 1;
          text-align: center;
        }
      }

      .items-wrapper {
        .category-header {
          background: #ffffff;
          color: rgba(0, 0, 0, 0.65);
          font-size: 18px;
          font-weight: 600;
          display: flex;
          justify-content: left;
          align-items: center;
          padding: 24px 16px 8px 16px;

          img {
            width: 24px;
            height: 24px;
            margin-right: 10px;
          }

          span {
            background: rgba(0, 0, 0, .04);
            border-radius: 8px;
            font-size: 12px;
            position: absolute;
            right: 16px;
            padding: 2px 8px;
            margin-left: 16px;
          }
        }

        .category-header:not(:first-of-type) {
          margin-top: 12px;
        }

        .item-list {
          background: #fff;
          margin-bottom: 12px;

          .item-row {
            height: 32px;
            line-height: 32px;
          }

          p {
            i {
              display: flex;
              justify-content: space-between;
            }

            span {
              font-size: 14px;
            }

            .price {
              float: right;
            }
          }
        }
      }

      .notice {
        background: #fff;
        border-top: 1px solid #f1f1f1;
        word-break: break-all;
        font-size: 14px;
        line-height: 24px;
        padding: 12px;

        img {
          max-width: 100%;
        }
      }
    }

    .footer {
      padding: 6px 10px;
      background: #fff;
      box-sizing: border-box;
      box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.05);

      .agreement-wrap {
        font-size: 12px;
        padding: 4px 8px;
        background-color: #f9f1e6;
        margin-bottom: 8px;
        border-radius: 4px;

      }

      .order-summary {
        display: flex;

        .order-price {
          flex: 1;
          padding-right: 20px;
          line-height: 40px;

          .price {
            color: #f63;
          }

          .price :first-letter {
            font-size: 12px;
          }
        }

        .order-button {
          background-image: var(--color-gradient);
          color: #ffffff;
          height: 40px;
          line-height: 40px;
          width: 160px;
          border: none;
        }

        .order-button--disable {
          background-image: var(--color-gradient);
          color: #ffffff;
          cursor: not-allowed;
          opacity: 0.5;
          height: 40px;
          line-height: 40px;
          width: 160px;
          border: none;
        }

        .add-item {
          background-image: linear-gradient(to right, #6bddd3, #0cc3bf);
        }

        .yue {
          background-image: var(--color-gradient);
          padding: 0 24px;
        }
      }


    }
  }

  .checkitem-row {
    padding: 12px 16px;
    border-bottom: rgba(0, 0, 0, .04) solid 1px;

    .checkitem-title {
      line-height: 30px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    .checkitem-name {
      display: inline-block;
      flex: 1;
      font-size: 14px;
      font-weight: 600;
      line-height: 30px;
      color: #333;
    }

    .combo-pkgItem-tag {
      font-weight: 400;
      font-size: 12px;
      margin-left: 10px;
      border-radius: 3px;
      padding: 2px;
      color: #666;
      border: #666 1px solid;
    }

    .checkitem-price {
      width: 120px;
      display: block;
      font-size: 16px;
      line-height: 30px;
      color: #ff6633;
      text-align: right;
      padding-right: 12px;
    }

    .checkitem-price:first-letter {
      font-size: 12px;
    }

    .checkitem-status {
      font-size: 13px;
      color: #ff6633;
    }

    .checkitem-desc {
      font-size: 13px;
      color: #888;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; //（希望显示N行-webkit-line-clamp的变为N）
      -webkit-box-orient: vertical;
    }

    .checkitem-footer {
      margin-top: 8px;
      display: flex;
    }

    .checkitem-tips {
      color: #29a2fd;
      background: #e3f3fa;
      border-radius: 3px;
      padding: 4px 8px;
      font-size: 12px;
      margin-right: 12px;
    }

    .red {
      color: #ff6633;
      background: #faebe7;
    }

    .checkitem-button-on {
      border: #26a2ff 1px solid;
      color: #26a2ff;
      background: #fff;
      border-radius: 14px;
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 90px;
      cursor: pointer;

      img {
        margin-right: 5px;
        width: 12px;
        height: 12px;
      }

      span {
        font-size: 12px;
        line-height: 16px;
      }
    }

    .checkitem-button-off {
      border: 1px solid #26a2ff;
      color: #fff;
      background: #26a2ff;
      border-radius: 14px;
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 90px;
      cursor: pointer;

      img {
        margin-right: 5px;
        width: 12px;
        height: 12px;
      }

      span {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  .item-popup {
    min-width: 300px;
    width: 90%;
    max-width: 450px;
    border-radius: 5px;
  }

  .item-wrapper {
    padding: 12px;
    background-color: #ffffff;

    .item-header {
      font-size: 18px;
      line-height: 32px;
    }

    .item-content {
      min-height: 320px;

      .item-info-box {
        h3 {
          font-size: 16px;
          margin: 10px 0;
          color: #333333;
        }

        font-size: 14px;
        color: #888;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
    }

    .item-footer {
      padding-top: 8px;
      text-align: center;
      border-top: 1px solid #f3f3f3;
    }
  }

  .popup-title {
    position: absolute;
    z-index: 1;
    font-size: 16px;
    left: 16px;
    top: 16px;
  }
</style>